/*
  BDEK "Wear it with" (sections/bdek-wear-it-with.liquid)
  Asks Shopify for hand-picked complementary products (Search & Discovery app). If there are any,
  they replace the fallback pieces; "this piece" stays first. Sizes and adding: bdek-style-it.js.
*/
(function () {
  function load(section) {
    if (section.dataset.bdekWearReady) return;
    section.dataset.bdekWearReady = 'true';
    var url = section.getAttribute('data-url');
    if (!url || !window.fetch) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelectorAll('[data-bdek-wear-list] [data-bdek-wear-other]');
        var currentId = section.getAttribute('data-product-id');
        var rows = Array.prototype.filter.call(fresh, function (row) {
          return row.getAttribute('data-product-id') !== currentId;
        });
        if (!rows.length) return;

        var list = section.querySelector('[data-bdek-wear-list]');
        list.querySelectorAll('[data-bdek-wear-other]').forEach(function (row) { row.remove(); });
        rows.forEach(function (row) { list.appendChild(document.importNode(row, true)); });
        section.hidden = false;
      })
      .catch(function () {
        // Keep the fallback pieces
      });
  }

  function initAll() {
    document.querySelectorAll('[data-bdek-wear]').forEach(load);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
